import { useState } from "react";
import { Table, Tbody, Td, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function FilteredDataTable({ data }) {
  const { t } = useTranslation();

  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const tillsReportFilteredData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return  <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th> # </Th>
              <Th>{t("pages.reports.reports_tables.business_date")}</Th>
              <Th>{t("pages.reports.reports_tables.branch")}</Th>
              <Th>{t("pages.reports.reports_tables.branch_reference")}</Th>
              <Th>{t("pages.reports.reports_tables.user")}</Th>
              <Th>{t("pages.reports.reports_tables.opened_at")}</Th>
              <Th>{t("pages.reports.reports_tables.opening_amount")}</Th>
              <Th>{t("pages.reports.reports_tables.net_cash_payment")}</Th>
              <Th>{t("pages.reports.reports_tables.total_pay_ins")}</Th>
              <Th>{t("pages.reports.reports_tables.total_pay_outs")}</Th>
              <Th>{t("pages.reports.reports_tables.total_cash_drops")}</Th>
              <Th>{t("pages.reports.reports_tables.closing_amount")}</Th>
              <Th>{t("pages.reports.reports_tables.expected_amount")}</Th>
              <Th>{t("pages.reports.reports_tables.variance")}</Th>
              <Th>{t("pages.reports.reports_tables.manual_drawer_opens")}</Th>
              <Th>{t("pages.reports.reports_tables.closed_at")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {tillsReportFilteredData?.map((item, index) => (
              <Tr key={index}>
                <Td>{index+1}</Td>
                <Td>{item?.BusinessDate}</Td>
                <Td>{item?.BranchName}</Td>
                <Td> {item?.BranchReference} </Td>
                <Td> {item?.User} </Td>
                <Td> {item?.OpenedAt} </Td>
                <Td> {item?.OpeningAmount} </Td>
                <Td> {item?.NetCashPayment} </Td>
                <Td> {item?.TotalPayins} </Td>
                <Td> {item?.TotalCashDrops} </Td>
                <Td> {item?.ClosingAmount} </Td>
                <Td> {item?.ExpectedAmount} </Td>
                <Td> {item?.Variance} </Td>
                <Td> {item?.ManualDrawerOpens} </Td>
                <Td> {item?.ClosedAt} </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
};
